
$controllers.foldermanager = {

	onLoad : function() {

		$controllers.foldermanager.currentFolder = 0;
		//$controllers.foldermanager.cachedFavouriteFolders = {folders:[]};
		//$controllers.foldermanager.cachedFolders = {folders:[]};

		// load team perms
		$controllers.foldermanager.teamPermissionsCurrentlyLoading = true;
		$models.folders.getListPerms({}, function($teamperms) {
			$controllers.foldermanager.teamPermissionsCurrentlyLoading = false;
			$controllers.foldermanager.teamPermissions = $teamperms;
		});


		// load all known folder types, for use on the Folder Edit dialog
		$controllers.foldermanager.typesCurrentlyLoading = true;
		$models.foldertypes.getList({}, function($data) {
			$controllers.foldermanager.typesCurrentlyLoading = false;
			$controllers.foldermanager.types = $data;
		});

		// load all known folder statuses, for use on the Folder Edit dialog
		$controllers.foldermanager.statusesCurrentlyLoading = true;
		$models.folderstatuses.getList({}, function($data) {
			$controllers.foldermanager.statusesCurrentlyLoading = false;
			$controllers.foldermanager.statuses = $data;
		});

	},

	onUnload : function() {
		$views.foldermanager.foldersGrid.destroy();
		$controllers.all.unbindEnterFormSubmissions();
		$controllers.foldermanager.teamPermissionsCurrentlyLoading = false;
		$controllers.foldermanager.typesCurrentlyLoading = false;
		$controllers.foldermanager.statusesCurrentlyLoading = false;
		clearInterval($controllers.foldermanager.folderCountTimer);
		if ($views.foldermanager.refValidator) {
			$views.foldermanager.refValidator.destroy();
		}
		if ($views.foldermanager.nameValidator) {
			$views.foldermanager.nameValidator.destroy();
		}
	},

	display : function($callback) {
		if (!$controllers.all.enforcePagePermissions('foldermanager')) { return false; }
		$controllers.all.showPage('foldermanager', 'contentpage');
		$controllers.foldermanager.displayWhenReady($callback);
	},

	displayWhenReady : function($callback) {

		// ensure the team permissions have finished loading before proceeding
		if (!$controllers.foldermanager.teamPermissionsCurrentlyLoading && !$controllers.foldermanager.typesCurrentlyLoading && !$controllers.foldermanager.statusesCurrentlyLoading) {
			$controllers.foldermanager.displayFolderManager($callback);
		} else {
			// data is still loading, lets wait 50 msec and then try again!
			setTimeout(function() {
				$controllers.foldermanager.displayWhenReady($callback);
			}, 50);
		}

	},

	displayFromHelp : function() {

		$controllers.foldermanager.display(function() {
			$controllers.all.help(true);
			$controllers.foldermanager.newFolder();
		});

	},

	displayFolderManager : function($callback) {

		// display the folder manager

		$views.foldermanager.display($callback);
		$views.all.scrollToTop();
		$controllers.all.setNavigation();

	},

	viewPage : function($pageNumber) {

		$views.foldermanager.currentPaginationPage = $pageNumber;
		$views.foldermanager.display(function() { });

	},

	newFolder : function() {
		$controllers.foldermanager.editFolder(0);
	},

	editFolder : function($folderid) {
		$controllers.foldermanager.currentFolder = $folderid;
		$views.foldermanager.renderFolderEditingScreen($folderid);
		$controllers.all.handleEnterFormSubmissions();
	},

	toggleHelpAreaFavouriteStatus : function() {
		// if no favourite available, un-tick create folder message in the help area... otherwise tick it!
		$models.favouriteFolders.getList({max_results: 5}, function($data) {
			if (!$data.folders || ($data.folders == null) || ($data.folders.length == 0)) {
				jQuery('#help .create-folder').removeClass('done');
			} else {
				jQuery('#help .create-folder').addClass('done');
			}
		});
	},

	toggleFavouriteFolder : function($folderid, $selector) {

		$selector = '#folder-list-item-'+$folderid+' .favourite-icon' + ($selector ? ', '+$selector : '');

		jQuery($selector).addClass('favourite-icon-progress');
		jQuery('#favourite').addClass('favourite-icon-progress');

		if (!jQuery($selector).hasClass('favourite-icon-active')) {
			$models.favouriteFolders.setItem($folderid,
				function() {
					//Success
					jQuery('#favourite').addClass('favourite-icon-active');
					jQuery('#favourite').removeClass('favourite-icon-progress');
					$views.foldermanager.foldersGrid.changeItem($folderid, {favourited:true});
					$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
					if (jQuery('#folder-list-item-'+$folderid+' li').hasClass('customPerms')) {
						$views.foldermanager.renderFolderPermsSummary($folderid);
					}
				}, function() {
          			//Error
					jQuery($selector).removeClass('favourite-icon-progress');
          			jQuery('#favourite').removeClass('favourite-icon-progress');
				}
			);
		} else {
			$models.favouriteFolders.deleteItem($folderid, function() {
				jQuery('#favourite').removeClass('favourite-icon-active');
				jQuery('#favourite').removeClass('favourite-icon-progress');
				$views.foldermanager.foldersGrid.changeItem($folderid, {favourited:false});
				$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
				if (jQuery('#folder-list-item-'+$folderid+' li').hasClass('customPerms')) {
					$views.foldermanager.renderFolderPermsSummary($folderid);
				}
			});
		}

	},

	saveFolder : function($reference, $name, $description, $teamid) {

		// validators
		if (!$views.foldermanager.refValidator.validOrError() ||
		    !$views.foldermanager.nameValidator.validOrError()
		    ) {
		    	return false;
		}
		if (jQuery('#sharing-custom').is(':checked') && (jQuery('.sharing-permissions ul li:visible').size() == 0)) {
			if ((jQuery('#sharingdata_email').val().length > 5) && (jQuery('#sharingdata_email').val() != 'Enter an email address')) {
				jQuery('.add_user_button').click();
			} else {
				$soupmail.modal.error('Please add at least one user under the "Share with these people only" options.<br><br>Alternatively, switch to "Share with my team".');
				return false;
			}
		}

		// get current folder id
		$currentFolder = $controllers.foldermanager.currentFolder;

		// get folder custom permissions mode
		$customPermissionsMode = (jQuery('#sharing-custom').is(':checked') ? true : false);
		//if (jQuery('#sharing-me').is(':checked')) { $customPermissionsMode = true; }

		// get type and status
		$type = parseInt(jQuery('#folderdata_type').val());
		$status = parseInt(jQuery('#folderdata_status').val());
		if (!$type) { $type = null; }
		if (!$status) { $status = null; }

		// save the folder
		$models.folders.setItem($currentFolder, $reference, $name, $description, $type, $status, $teamid, $customPermissionsMode, function($data) {

			// are we saving a new folder
			var $isNewFolder = ($currentFolder == 0);
			var $newFolderId = 0;

			// prepare api folders response, we'll now update the main folders list with this data, via a trick to the existing rendering function...
			if ($isNewFolder) {
				$data.folder._isNewPrependedFolder = true;
				$controllers.foldermanager.newFolderPrepend = $data.folder;
				$newFolderId = $data.folder.id;
				$currentFolder = $newFolderId;
				jQuery('#foldermanager-folders .folder-list').prepend('<div id="folder-list-item-'+$newFolderId+'" class="manage-folder-list-item row-'+$newFolderId+'" data-id="'+$newFolderId+'"></div>');
			}

			//$folderCountPreSave = jQuery('#folder-manager .folder-count span').html();
			$data.folder._visible = true;
			$views.foldermanager.foldersGrid.changeItem($currentFolder, $data.folder);
			if (jQuery('#folder-list-item-'+$data.folder.id).hasClass('view')) {
				if (jQuery('#folder-list-item-'+$data.folder.id+' li').hasClass('customPerms')) {
					$views.foldermanager.renderFolderPermsSummary($data.folder.id);
				}
			}
			if ($isNewFolder) {
				$controllers.foldermanager.pollForNewFolderCreation($newFolderId);
				//$views.foldermanager.foldersGrid.totalResultCount++;
				//jQuery('#folder-manager .folder-count span').html($views.foldermanager.foldersGrid.totalResultCount);
				//jQuery('#folder-manager .folder-count').show();
				$views.all.scrollToTop();
			}
			$views.foldermanager.closeFolderEditingScreen();
			$cached.folders.dataHasChanged();

		});

	},

	// when saving a *new* folder, run a timer to increment the folder counts
	pollForNewFolderCreation : function($newFolderId) {
		console.log('Folder save operation called - polling for update');
		$controllers.foldermanager.folderCountTimer = setInterval(function() {
			$models.folders.getItem($newFolderId, function($data) {
				console.log('New folder now exists, lets update the list');
				clearInterval($controllers.foldermanager.folderCountTimer);
				$views.foldermanager.foldersGrid.reset();
				$views.foldermanager.foldersGrid.load();
			}, function() {
				console.log('New folder does not exist just yet, lets wait a moment and then poll again');
			});
		}, 2000);
	},

	deleteFolder : function($folderid) {
		$soupmail.modal.deletion("Are you sure you wish to remove this folder from Soup Mail?<br/><br/>This will permanently remove the folder and its emails from the Soup Mail server.", function() {
			$views.foldermanager.foldersGrid.removeItem($folderid);
			$views.foldermanager.foldersGrid.totalResultCount--;
			jQuery('#folder-manager .folder-count span').html($views.foldermanager.foldersGrid.totalResultCount);
			$models.folders.deleteItem($folderid, function() {
				$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
				// Bug fix: correct navigation:
				$controllers.all.setNavigation();
			});
		});
	},

	archiveFolder : function($folderid) {
		$soupmail.modal.question("You are requesting a download of the contents of this folder. This download will be prepared for you, and when it's finished you will receive an email containing a link to download a zipped archive of the emails in the folder.", function() {
			$models.folders.archiveItem($folderid, function() {
				$soupmail.notification.message("Download is being prepared in the background.  When it's finished you will receive an email.");
			});
		});
	},

	addUserToCustomPerms : function() {

		// quick validation
		var emailAddress = jQuery('#sharingdata_email').val();
		emailAddress = jQuery.trim(emailAddress);
		if (!emailAddress || emailAddress == 'Enter an email address') {
			$soupmail.modal.error('Please enter an email address');
			return false;
		}
		var validator = new $soupmail.validator();
		if (!validator.validateEmail(emailAddress)) {
			$soupmail.modal.error('Please enter a valid email address');
			return false;
		}
		if ($models.folderpermissions.hasPermissionsWithinCurrentFolder(emailAddress)) {
			$soupmail.modal.notice('Please note, the email address you are attempting to add already has permissions within this folder.  Unable to add the same person twice.  Please edit the existing permissions for this user.');
			return false;
		}
		if ($models.login.hasMatchingEmailDomain(emailAddress) && $models.login.hasAdminPrivileges() && !$models.folderpermissions.hasPermissionsWithinMyTeam(emailAddress)) {
			var question = 'It looks like you are sharing with someone who does not yet have a Soup mail account and who may be in your team, based on their email domain "'+$soupmail.string.extractEmailDomain(emailAddress)+'", which is the same as yours.<br /><br />Do you want to add '+emailAddress+' to your team now?';
			$soupmail.modal.question(question,
			    {cssClass:'button-ok', labelText:'Yes', clickEvent:function() {
				$controllers.teamsettings.display(function() {
					$controllers.teamsettings.addUser(emailAddress);
				});
			}}, {cssClass:'button-no', labelText:'No', clickEvent:function() {
				$controllers.foldermanager.addUserToCustomPermsAfterValidation(emailAddress);
			}}, {cssClass:'button-cancel', labelText:'Cancel'});
			return false;
		}
		if (!$config.enableSharingOutsideOwnTeam && !$models.login.hasAdminPrivileges() && !$models.folderpermissions.hasPermissionsWithinMyTeam(emailAddress)) {
			$models.users.getAdmins(function($adminUsers) {
				var teamAdminList = $soupmail.string.implodeObjectList(' / ', $adminUsers, 'first_name', 'last_name');
				$soupmail.modal.notice('You do not have permission to share with someone who is not a member of your team.<br /><br />You will need to contact a team admin ('+teamAdminList+') before you can share with this person. Your team admin can either add this person to your team or share this folder directly with them.');
			});
			return false;
		}
		if ($models.login.hasMatchingEmailDomain(emailAddress) && !$models.login.hasAdminPrivileges() && !$models.folderpermissions.hasPermissionsWithinMyTeam(emailAddress)) {
			$models.users.getAdmins(function($adminUsers) {
				var teamAdminList = $soupmail.string.implodeObjectList(' / ', $adminUsers, 'first_name', 'last_name');
				$soupmail.modal.notice('It looks like you are sharing with someone who does not yet have a Soup mail account and who may be in your team, based on their email domain "'+$soupmail.string.extractEmailDomain(emailAddress)+'", which is the same as yours.<br /><br />You will need to contact a team admin ('+teamAdminList+') before you can share with this person. Your team admin can either add this person to your team or share this folder directly with them.');
			});
			return false;
		}

		// passed validation, now actually add the user
		$controllers.foldermanager.addUserToCustomPermsAfterValidation(emailAddress);

	},

	addUserToCustomPermsAfterValidation : function(emailAddress) {

		// IMPORTANT: this must be in a separate function from addUserToCustomPerms() above, because of the Yes/No/Cancel implementation above
		jQuery('input.add_user_button').hide();
		var perms = jQuery('#add_a_user select').val();
		var permissionsData = JSON.stringify({permissions: $models.folders.encodePermsSet(emailAddress, perms)});
		$views.foldermanager.permsGrid.changeItem($soupmail.string.stringHtmlAttributeSafe(emailAddress), {_visible: true, _editable:false, _isNewPrependedFolder:true, id: $soupmail.string.stringHtmlAttributeSafe(emailAddress), email: emailAddress, permissions:{decodedVal:perms, decodedLabel:$models.folders.translatePermsValue(perms)}});
		$views.foldermanager.permsGrid.render();
		$views.foldermanager.renderFolderPermsSummaryIfNotExists($models.folderpermissions.folderid);
		$views.foldermanager.summaryGrid.changeItem($soupmail.string.stringHtmlAttributeSafe(emailAddress), {_visible: true, _editable:false, _isNewPrependedFolder:true, id: $soupmail.string.stringHtmlAttributeSafe(emailAddress), email: emailAddress, permissions:{decodedVal:perms, decodedLabel:$models.folders.translatePermsValue(perms)}});
		$views.foldermanager.summaryGrid.render();
		$models.folderpermissions.setItem(permissionsData, function() {
			jQuery('input.add_user_button').show();
			$views.foldermanager.permsGrid.reset();
			$views.foldermanager.permsGrid.load(function() {
				$views.foldermanager.summaryGrid.reset();
				$views.foldermanager.summaryGrid.load();
			});
			jQuery('#sharingdata_email').val('Enter an email address');
			jQuery('#add_a_user #sharingdata_email').css({'color': '#c2c2c2'});
			$views.foldermanager.centreFolderEditingScreen();
		});

	}

};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.foldermanager.js